import React, { useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import SmuBadge from "../../utils/smu-badge/SmuBadge";
import SmuSearch from "../../utils/smu-search/SmuSearch";
import { COLOR_PRIMARY } from "../../constants/colors";
import { prepareText, pascalCase } from "../../helpers";
import SmuTable from "../../utils/smu-table/SmuTable";
import { useNavigate } from "react-router-dom";

const PromotionsTable = ({ articles, promotionId, loading }) => {
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        name: "Sección",
        selector: (row) => row.SECCION,
        cell: (row) => <div className="cell">{pascalCase(row.SECCION)}</div>,
        sortable: true,
      },
      {
        name: "Linea",
        selector: (row) => row.LINEA,
        cell: (row) => <div className="cell">{pascalCase(row.LINEA)}</div>,
        sortable: true,
      },
      {
        name: "Categoria",
        selector: (row) => row.DESC_CATEGORIA,
        cell: (row) => (
          <div className="cell">{pascalCase(row.DESC_CATEGORIA)}</div>
        ),
        sortable: true,
      },
      {
        name: "Sap",
        selector: (row) => row.ID_COD_SAP,
        cell: (row) => <div className="cell">{row.ID_COD_SAP}</div>,
        sortable: true,
      },
      {
        name: "Ean",
        selector: (row) => row.EAN,
        cell: (row) => <div className="cell">{row.EAN}</div>,
        sortable: true,
      },
      {
        name: "Descipción",
        selector: (row) => row.DESCRIPCION,
        cell: (row) => (
          <div className="cell">{pascalCase(row.DESCRIPCION)}</div>
        ),
        sortable: true,
      },
      {
        name: "UMV",
        selector: (row) => row.UNIDAD_VENTA,
        cell: (row) => <div className="cell">{row.UNIDAD_VENTA}</div>,
        sortable: true,
      },
      {
        name: "Precio Modal",
        selector: (row) => row.PRECIO_NORMAL,
        cell: (row) => <div className="cell">{row.PRECIO_NORMAL}</div>,
        sortable: true,
      },
      {
        name: "Factor",
        selector: (row) => row.FACTOR,
        cell: (row) => <div className="cell">{row.FACTOR}</div>,
        sortable: true,
      },
      {
        id: "FECHA_INICIO",
        name: "F. inicio",
        selector: (row) => row.FECHA_INICIO,
        cell: (row) => (
          <div className="cell text-truncate">{row.FECHA_INICIO}</div>
        ),
        sortable: true,
      },
      {
        name: "F. termino",
        selector: (row) => row.FECHA_TERMINO,
        cell: (row) => (
          <div className="cell text-truncate">{row.FECHA_TERMINO}</div>
        ),
        sortable: true,
      },
      {
        name: "Precio Of.",
        selector: (row) => row.PRECIO_OFERTA,
        cell: (row) => <div className="cell">{row.PRECIO_OFERTA}</div>,
        sortable: true,
      },
      {
        name: "Descargas",
        selector: (row) => row.DESCARGA,
        cell: (row) => <div className="cell">{row.DESCARGA}</div>,
        sortable: true,
      },
    ],
    []
  );

  const [search, setSearch] = useState("");

  const filteredArticles = useMemo(() => {
    const _search = prepareText(search.trim());
    return articles.filter((a) => {
      const _section = prepareText(a.SECCION);
      const _line = prepareText(a.LINEA);
      const _category = prepareText(a.DESC_CATEGORIA);
      const _sap = prepareText(a.ID_COD_SAP);
      const _ean = prepareText(a.EAN);
      const _desc = prepareText(a.DESCRIPCION);
      const _sale = prepareText(a.UNIDAD_VENTA);
      const _price = prepareText(a.PRECIO_NORMAL);
      const _factor = prepareText(a.FACTOR);
      const _start = prepareText(a.FECHA_INICIO);
      const _end = prepareText(a.FECHA_TERMINO);
      const _offer = prepareText(a.PRECIO_OFERTA);
      return (
        _section.includes(_search) ||
        _line.includes(_search) ||
        _category.includes(_search) ||
        _sap.includes(_search) ||
        _ean.includes(_search) ||
        _desc.includes(_search) ||
        _sale.includes(_search) ||
        _price.includes(_search) ||
        _factor.includes(_search) ||
        _start.includes(_search) ||
        _end.includes(_search) ||
        _offer.includes(_search)
      );
    });
  }, [search, articles]);

  return (
    <Card className="smu-card">
      <Card.Header className="d-flex py-4">
        <div className="d-flex align-items-center me-auto">
          <SmuBadge color="#B1E5FC" />
          <span className="fs-5 ms-3 me-auto">ARTICULOS</span>
        </div>
        <div className="d-flex align-items-center">
          <SmuSearch
            value={search}
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>
      </Card.Header>
      <div className="px-3 d-flex">
        <strong className="me-2" style={{ color: COLOR_PRIMARY }}>
          Id Promo:
        </strong>
        {promotionId}
        <button
          className="btn btn-primary btn-sm ms-auto border-0"
          onClick={() => navigate(-1)}
          style={{ backgroundColor: COLOR_PRIMARY }}
        >
          Atras
        </button>
      </div>
      <Card.Body>
        <SmuTable
          columns={columns}
          data={filteredArticles}
          loading={loading}
          defaultSortFieldId="FECHA_INICIO"
          defaultSortAsc={false}
        />
      </Card.Body>
    </Card>
  );
};

export default PromotionsTable;
